import { Divider } from "ant-design-vue";
const { ...other } = Divider;
const YwDivider = {
	...other,
	name: "YwDivider",
};
YwDivider.install = function (Vue) {
	Vue.component(YwDivider.name, YwDivider);
};
export default YwDivider;
